import { useStores } from "stores";
import { Text, Link } from "@chakra-ui/react";
import { Divider } from "components/divider/Divider";
import { Filler } from "components/filler/Filler";
import { ResendEmail } from "./ResendEmail";
import { Container } from "components/container/Container";
import { signUpComponentStyles } from "./registerComponents";
import { observer } from "mobx-react";

export const ConfirmEmail = observer(function ConfirmEmail() {
  const { authStore } = useStores();
  const { resendEmail } = authStore;
  const handleClick = () => authStore.setResendEmail(!resendEmail);

  if (resendEmail) return <ResendEmail />;

  return (
    <Container textAlign="center" {...signUpComponentStyles}>
      <Filler.SVGFiller
        imagePath="success/Checkmark"
        variant="other"
        headline="Success!"
        mt="0"
      />
      <Text mt="4" textStyle="base">
        Woohoo! Your account has been created. Please check your email to verify
        and log in to your account.
      </Text>

      <Divider color="border.divider" m="40px 0" />

      <Text textStyle="caption">
        If you don't see your verification email, please check <br /> your spam
        folder or
        <Link onClick={handleClick} textStyle="captionLink" p="0 4px">
          click here
        </Link>
        to resend.
      </Text>
    </Container>
  );
});
